<template>
    <div>
        <div class='review-summary-container'>
            <div class='average-rating'>{{average_rating}}</div>
            <div>
                <div><Ratings :rating='average_rating' /></div>
                <div class='based-on-text'>Based on {{total_reviews}} reviews</div>
            </div>
        </div>
    </div>
</template>

<script>
import Ratings from '@/ecom/components/products/single_product/reviews/Ratings.vue';

export default {
    components: {Ratings},
    props: ['total_reviews', 'average_rating']
}
</script>

<style lang="scss" scoped>
.review-summary-container{
    display: flex;
    gap: 10px;
    align-items: center;
}

.average-rating{
    font-size: 2.6rem;
}

.based-on-text{
    color: var(--black);
}
</style>